import React from "react";
import '../styles/days.css'

import { useState } from "react";

function Days() {
  const [daysDate, setDaysDate] = useState("");

  function getDate(e) {

    // if(!daysDate){
    //   return;
    // }
    const today = new Date();
    const finalDate = today.setDate(today.getDate() + parseInt(e));
    const newDate = new Date(finalDate);
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    setDaysDate(newDate.toLocaleString("en-US", options));
  }

  return (
    <>
      
      <h2>Calculate Date</h2>
      <label className="label-days">
        <input type="number" className="active days-active dark-input" onChange={(e) => getDate(e.target.value)} />
        <p className="content-p">Days from today is</p>
        <p className="readOnly p-readonly">{daysDate}</p>
      </label>
    </>
  );
}

export default Days;
